// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZeLRZ","name":"styles_name__3gusJ","phone":"styles_phone__3rRG2"};